import newSearchBar from './src/newSearchBar';

newSearchBar.install = function(Vue) {
    Vue.component(newSearchBar.name, newSearchBar);
};

export default newSearchBar;
